function getCartData() {
    window.$.getJSON('/cart.js')
        .done((cart) => {
            if (cart) {
                window.cartData = cart;
                resetCartCountForConfigurator(cart.items);
                document.dispatchEvent(new CustomEvent('cart.items_refreshed'));
            }
        })
}

const resetCartCountForConfigurator = (cartItems) => {
    const configuratorItems = cartItems.filter(item => item.properties.type !== "adjustment");
    const configuratorCount = configuratorItems.length;
    const configuratorCountElement = document.querySelector('.cart-count-bubble span');
    if (configuratorCountElement && configuratorCount) {
      configuratorCountElement.textContent = configuratorCount;
    }
}
  


/**
 * call this method on load of the page
 * if it returns null, no need to do anything
 * if it returns an object, update the cart
 * @param {Object} cartData - current cart object
 */

function checkCartForCustomisedProducts(cartData) {

    // quantities should be same
    var customisedProductsObj = {};
    var adjustmentProductsObj = {};
    var adjustmentProductsObj2 = {};
    var productUpdatesObj = {};
    var totalNormalProducts = 0;
    var adjustmentItemTotal = {};

    for (var i = 0; i < cartData.items.length; i++) {
        totalNormalProducts += 1;
        var item = cartData.items[i];
        if(item.properties && item.properties.edge && item.properties.thickness) {
            // customised product
            customisedProductsObj[item.properties.identifier] = {
                quantity: item.quantity,
                type: 'main',
                variant_id: item.variant_id,
                totalAdjustment: item.properties.totalAdjustment,
                identifier: item.properties.identifier,
                line: i+1
            }
        } else if(item.properties && (item.properties['hanging tools'] || item.properties['_is_hexagon'] === true || item.properties['selected_mode'])) {
            // customised product
            customisedProductsObj[item.properties.identifier] = {
                quantity: item.quantity,
                type: 'main',
                variant_id: item.variant_id,
                totalAdjustment: item.properties.totalAdjustment,
                identifier: item.properties.identifier,
                line: i+1
            }
        }

        if(item.properties && item.properties.type === "adjustment" && item.sku === "adjustment") {
            totalNormalProducts -= 1;
            // adjustment product
            const tempObj = {
                quantity: item.quantity,
                type: 'adjustment',
                parent_vid: item.properties.parent_vid,
                variant_id: item.variant_id,
                identifier: item.properties.identifier,
                line: i+1
            }

            if(item.price > 0) {
                adjustmentProductsObj[item.properties.identifier] = tempObj;
    
                let temp = adjustmentProductsObj2[item.properties.identifier] || [];
                temp.push(tempObj);
                adjustmentProductsObj2[item.properties.identifier] = temp

            }

            adjustmentItemTotal[item.properties.identifier] = (adjustmentItemTotal[item.properties.identifier] || 0) + (Number(item.price) * item.quantity)/100;
        }
    }

    
    for(let identifier in customisedProductsObj) {
        // if there is no total adjustment, we can skip
        if(!customisedProductsObj[identifier].totalAdjustment) {
            continue;
        }

        if(identifier in adjustmentProductsObj2) {
            for(let tempobj of adjustmentProductsObj2[identifier]) {
                if(customisedProductsObj[identifier].quantity != tempobj.quantity) {
                    // set adjustment quantity equal to main product's quantity
                    productUpdatesObj = {
                        line: tempobj.line,
                        quantity: customisedProductsObj[identifier].quantity
                    }
                }
            }
        } else {
            // main product is there but not the adjustment
            // remove the main product
            productUpdatesObj = {
                line: customisedProductsObj[identifier].line,
                quantity: 0
            }
        }

        // continue
        // if(identifier in adjustmentProductsObj) {
        //     if(customisedProductsObj[identifier].quantity != adjustmentProductsObj[identifier].quantity) {
        //         // set adjustment quantity equal to main product's quantity
        //         productUpdatesObj = {
        //             line: adjustmentProductsObj[identifier].line,
        //             quantity: customisedProductsObj[identifier].quantity
        //         }
        //         // productUpdatesObj[adjustmentProductsObj[identifier].variant_id] = customisedProductsObj[identifier].quantity;
        //     }
        // } else {
        //     // main product is there but not the adjustment
        //     // remove the main product
        //     productUpdatesObj = {
        //         line: customisedProductsObj[identifier].line,
        //         quantity: 0
        //     }
        //     // if(customisedProductsObj[var_id].totalAdjustment) {
        //     //     productUpdatesObj[var_id] = 0
        //     // }
        // }
    }

    if(!Object.keys(productUpdatesObj).length) {
        for(let identifier in adjustmentProductsObj2) {
            if(identifier in customisedProductsObj) {
                // if the total don't match
                if(customisedProductsObj[identifier].totalAdjustment && (customisedProductsObj[identifier].quantity * customisedProductsObj[identifier].totalAdjustment != adjustmentItemTotal[identifier])) {
                    productUpdatesObj = {
                        line: customisedProductsObj[identifier].line,
                        quantity: 0
                    }
                }
            } else {
                if(adjustmentProductsObj2[identifier][0] && adjustmentProductsObj2[identifier][0].line) {
                    productUpdatesObj = {
                        line: adjustmentProductsObj2[identifier][0].line,
                        quantity: 0
                    }
                }
            }
        }
    }

    // console.log({customisedProductsObj, adjustmentProductsObj2, productUpdatesObj})

    // for(var i=0; i<10; i++) {
    //     setTimeout(function(){
    //         $('#CartCount').html(totalNormalProducts);
    //     }, i*1000);
    // }
    return productUpdatesObj;
        
}


/**
 *
 * @param {Object} updates - Object of product_ids and new_qty to be moidied
 */

function callCartUpdates(updates) {

    var params = {
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: updates,
        success: function (line_item) {
            window.location.reload();
        },
        error: function () {
            console.log("fail");
            window.location.reload();
        }
    };
    $.ajax(params);
}


async function changeItemQuantity(updates, reload = true) {

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
    });

    const line_items = await response.json();

    if (reload) {
        window.location.reload();
    }

    return line_items;

    // var params = {
    //     type: 'POST',
    //     url: '/cart/change.js',
    //     dataType: 'json',
    //     data: updates,
    //     success: function (line_item) {
    //         getCartData();
    //     },
    //     error: function () {
    //         console.log("fail");
    //         window.location.reload();
    //     }
    // };
    // $.ajax(params);
}

async function updateItemsQuantity(updates) {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({updates})
    });
    const line_items = await response.json();
    return line_items;
}


document.addEventListener('DOMContentLoaded', function () {
    if (window.$ && window.$.getJSON) {
        getCartData();
    } else {
        // wait for jQuery to load
        setTimeout(function () {
            getCartData();
        }, 1000);
    }

    document.addEventListener('cart.items_refreshed', function () {

        let updates = checkCartForCustomisedProducts(window.cartData);
        console.log({updates})

        if (updates && Object.keys(updates).length) {
            callCartUpdates(updates);
        }
    });
  
  
    const updateVariantsOnChangeOrDelete = async (identifier, variantId, itemIndex, quantity) => {
        const matchingVariantItems = window.cartData.items.filter(item => item.variant_id == variantId);
        const matchingIdentifierItems = window.cartData.items.filter(item => item.properties.identifier == identifier);

        console.log({ matchingVariantItems, matchingIdentifierItems, identifier, variantId, cartData: window.cartData });
        return;
        if (matchingVariantItems.length === 1 && matchingIdentifierItems.length > 0) {
            // change all items quantity at once
            let updates = {};
            for (let item of matchingIdentifierItems) {
                updates[item.variant_id] = Number(quantity);
            }
            await updateItemsQuantity(updates);
            window.location.reload();
        } else {
            let updates = {
                'line': itemIndex,
                'quantity': quantity
            }
            changeItemQuantity(updates, false);
        }
    }

  	document.querySelectorAll('.configurator-item input.quantity__input').forEach(input => {
      input.addEventListener('change', async function(event) {
        event.stopPropagation();
        event.preventDefault();
        console.log("item will change");
        const identifier = event.target.getAttribute('data-configurator-identifier');
        const variantId = event.target.getAttribute('data-quantity-variant-id');

        const quantity = event.target.value;
        await updateVariantsOnChangeOrDelete(identifier, variantId, event.target.getAttribute('data-index'), quantity);

        // const matchingVariantItems = window.cartData.items.filter(item => item.variant_id == variantId);
        // const matchingIdentifierItems = window.cartData.items.filter(item => item.properties.identifier == identifier);

        // console.log({ matchingVariantItems, matchingIdentifierItems, identifier, variantId, cartData: window.cartData });
        // if (matchingVariantItems.length === 1 && matchingIdentifierItems.length > 0) {
        //     // change all items quantity at once
        //     let updates = {};
        //     for (let item of matchingIdentifierItems) {
        //         updates[item.variant_id] = Number(event.target.value);
        //     }
        //     await updateItemsQuantity(updates);
        //     window.location.reload();
        // } else {
        //     let updates = {
        //         'line': event.target.getAttribute('data-index'),
        //         'quantity': event.target.value
        //     }
        //     changeItemQuantity(updates, false);
        // }

        // if (identifier) {
        //     window.cartData.items.map(async (item) => {
        //         let updates = {
        //           'line': $(event.target).data('item_index'),
        //           'quantity': event.target.value
        //         }
        //         await changeItemQuantity(updates, false);
        //     });
        // }
      })
    });


    document.querySelectorAll('.configurator-item cart-remove-button').forEach(button => {
        button.addEventListener('click', async function(event) {
          event.stopPropagation();
          event.preventDefault();
          console.log("item will change");
          const removeButton = event.target.closest('cart-remove-button');
          if (!removeButton) return;

          const itemIndex = removeButton.getAttribute('data-index');

          const identifier = removeButton.getAttribute('data-configurator-identifier');
          const variantId = removeButton.getAttribute('data-quantity-variant-id');
  
          const quantity = 0;
          await updateVariantsOnChangeOrDelete(identifier, variantId, itemIndex, quantity);
        })
      })
});